"use client";
import dynamic from "next/dynamic";
import { useEffect, useState } from "react";
import PhoneFrame from "./PhoneFrame";
import Spinner from "../ui/Spinner";

const StepsProgress = dynamic(() => import("./StepsProgress"), {
  ssr: true,
  loading: () => <Spinner />,
});

function StepsSwiper({ steps }) {
  const [activeId, setActiveId] = useState(1);
  const [progress, setProgress] = useState(0);
  const DURATION = 5000;

  useEffect(() => {
    const t = setInterval(() => {
      setActiveId((prevId) => (prevId === steps.length ? 1 : prevId + 1));
    }, DURATION);
    setProgress(0);
    return () => clearInterval(t);
  }, [steps.length]);

  useEffect(() => {
    let startTime;
    const animate = (currentTime) => {
      if (!startTime) startTime = currentTime;
      const elapsed = currentTime - startTime;
      const progress = Math.min((elapsed / DURATION) * 100, 100);

      setProgress(progress);

      if (elapsed < DURATION) {
        requestAnimationFrame(animate);
      }
    };

    const animationFrame = requestAnimationFrame(animate);

    return () => cancelAnimationFrame(animationFrame);
  }, [activeId]);

  return (
    <div className="steps-swiper w-[80vw] mx-auto min-[768px]:flex justify-center gap-12 min-[1170px]:gap-40 ">
      <PhoneFrame steps={steps} activeId={activeId} />
      <div className="all-steps gap grid grid-rows-4 py-10 items-center">
        <StepsProgress
          steps={steps}
          setActiveId={setActiveId}
          activeId={activeId}
          progress={progress}
        />
      </div>
    </div>
  );
}

export default StepsSwiper;
